import React from 'react';
import { connect } from 'react-redux'
import '../login.css';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { clearRegState } from '../actions/registrationActions'
import { hideGlobalMessage } from '../actions/environmentActions';
import { login } from '../actions/authActions';
import { buildNumber, cdnPath } from '../constants/config';
import { clearToken } from '../utils/tokenUtil';
import { hashHistory   } from 'react-router'; 
import Clear from 'material-ui/svg-icons/content/clear';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

class LoginPage extends React.Component {

    
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      alertMessage: "",
      allowThumbprint: false,
      iconType: null,
      keypass: "",
      open: false,
      forceDialog: false,
    };

    this.authenticate = this.authenticate.bind(this);
    this.createAccount = this.createAccount.bind(this);
    this.keychainFetchSuccess = this.keychainFetchSuccess.bind(this);
    this.showIosTouchId = this.showIosTouchId.bind(this);
    this.checkLocalStorageForUserId = this.checkLocalStorageForUserId.bind(this);
    this.isAndroidTouchSensorAvailable = this.isAndroidTouchSensorAvailable.bind(this);
    this.samsungIdentifyCallback = this.samsungIdentifyCallback.bind(this);
    this.loginUserFromKeychain = this.loginUserFromKeychain.bind(this);
    this.checkKeychainForCredentials = this.checkKeychainForCredentials.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.forceDialog = this.forceDialog.bind(this);
    this.decideFrameworkAndAlert = this.decideFrameworkAndAlert.bind(this);
  }

  componentWillMount(){
      this.props.clearRegState();
  }

  componentDidMount(){
    var self = this;

    if(!document.URL.startsWith('http')) {      
      setTimeout(self.checkLocalStorageForUserId, 2500);
    }

  }

  forceDialog(){
    this.setState({forceDialog: true});
    if(this.state.username == "") { 
      this.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
      return;
    }
    this.checkLocalStorageForUserId();
  }
  


  checkForKeyChainCrash = async () => {
    if(window.NativeStorage){

      //go get the value this is an async call so we will want to await it.
      await this.getCrashDetectionValue()
      .then(()=>{
        console.log("Result of GetCrashDetection")
      })

      return this.state.crashD;
    }

    return false;
  }

  getCrashDetectionValue = async () => {
    return new Promise ((resolve, reject) => {
      window.NativeStorage.getItem(
        'medefykeychaincrash',
        (value)=>{ 
          console.log("Got Value From Storage", value)
          if(value === true && window.dasKeychain && this.state.username != ""){
            window.dasKeychain.removeForKey(()=>{ console.log("Removing Stored Value")}, ()=>{ console.log("Error Removing Stored Value")}, this.state.username, "medefyservice")
          }
          this.setState({crashD:value}, resolve) },
        (error) => { 
          console.log("Error Getting From Storage", error)
          this.setState({crashD:false}, resolve)}
        )
    })
  }

  checkLocalStorageForUserId() {
    var self = this;

    if(window.NativeStorage) {

      if(this.state.username == "") {

        window.NativeStorage.getItem("medefyusername",
          function(username){
            self.setState({username : username, showClearButton: true});
          },
          function(){
            // can't put this here because we don't want it firing for non-thumbprint phones
            //self.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
          }
        );
      }

      //if((window.location.href.indexOf('signout') == -1) || (self.state.forceDialog)) {
      self.checkForKeyChainCrash()  
      .then((v) => {
        if(v === false){
          console.log("Start Framework Detection")
          self.decideFrameworkAndAlert();
        }
        else {
          console.log("Manual Login Required")
        }
      })
      //}
    }
  }

  checkKeychainForCredentials() {
    if(window.dasKeychain && this.state.username != "") {
        this.setState({allowThumbprint: true});
        window.dasKeychain.getForKey(this.keychainFetchSuccess, this.keychainFetchFailure, this.state.username, 'medefyservice');
        return true;      
    }
    else{
      //alert('no keychain');
      //this.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
      return false;
    }
  }

  keychainFetchSuccess(password) {
    this.setState({keypass: password});
    //this.loginUserFromKeychain();
    //this.decideFrameworkAndAlert();
  }

  keychainFetchFailure() {
    //alert('keychain fail');
    //this.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
  }

  decideFrameworkAndAlert(){
    var self = this;

    // if(window.FingerprintAuth) {
    //   window.FingerprintAuth.isAvailable(self.isAndroidTouchSensorAvailable, function(){
    //     //alert('no android touch available');
    //   });
    // }
    // else 
    if(window.Fingerprint){
      window.Fingerprint.isAvailable(self.isAndroidTouchSensorAvailable, function (message) {
        //alert("Fingerprint not available");
        if(window.SamsungPass) {

          window.SamsungPass.checkSamsungPassSupport(
            function() {
              
              self.setState({allowThumbprint: true, iconType: "touch"});
      
              if((window.location.href.indexOf('signout') == -1) || (self.state.forceDialog)) {
                
                if(self.checkKeychainForCredentials(self.state.username)){
                  window.SamsungPass.checkForRegisteredFingers(function() {
                    
                    window.SamsungPass.startIdentifyWithDialog(
                      self.samsungIdentifyCallback, 
                      function() {
                        //alert('Samsung fingerprint error')
                        // console.log('User Cancelled out of dialog');
                      });
              
                  }, 
                  function() {
                    //self.setState({alertMessage: "No samsung touch id", open:true});
                    self.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
                  });
                }
              }
            },
            function() { 
              //self.setState({alertMessage: "nope", open:true});
            }
          );
        }
      });
    }
    else if(window.plugins.touchid){ // ios 
        window.plugins.touchid.isAvailable(self.showIosTouchId, 
          function() {
            // touch not available for iOS
              //alert('touch not available');
          });
    }
    else{
      //browser
    }
  }

  isAndroidTouchSensorAvailable(result) {
    var self = this;
    // On Android, just because the sensor is available, that doesn't mean
    // the phone is programmed to use the Android touchId framework. For example,
    // Samsung Phones use Samsung's proprietery auth framework - which is a separate cordova plugin.
    //if (result == "OK" || result == "finger") {

      self.setState({allowThumbprint: true, iconType: "touch"});

      if((window.location.href.indexOf('signout') == -1) || (self.state.forceDialog)) {

        if(self.checkKeychainForCredentials(self.state.username)){
          
          window.Fingerprint.show({
            clientId: "Medefy",
            description: ""
            //clientSecret: "o7aoOMYUbyxaD23oFAnJ" //Necessary for Android encrpytion of keys. Use random secret key.
          }, 
          function (){
            //alert("Authentication successfull");
            self.loginUserFromKeychain();
          }, 
          function (err){
            //alert("Authentication invalid " + err);
          });
        }
      }
    //}
  }



  samsungIdentifyCallback(something){
    this.loginUserFromKeychain();
  }

  showIosTouchId(type) {

    //https://github.com/EddyVerbruggen/cordova-plugin-touch-id#usage
    var self = this;

    self.setState({iconType: (type ? type: "touch") });
    self.setState({allowThumbprint: true});

    if((window.location.href.indexOf('signout') == -1) || (self.state.forceDialog)) {

      if(self.checkKeychainForCredentials(self.state.username)){
        
        window.plugins.touchid.verifyFingerprint(
          'Scan your fingerprint please', // this will be shown in the native scanner popup
          function(msg) { 
              // success handler: fingerprint accepted
              var key = self.state.keypass;
  
              //self.checkKeychainForCredentials(self.state.username);
  
              self.setState({ password: key});
  
              //self.props.loginUser(self.state.username, self.state.password);
              self.loginUserFromKeychain();
          }, 
          function(msg) {
            // this fires if user clicks cancel
            //self.setState({ alertMessage: "Fingerprint not accepted. ", open: true});
              //alert('Fingerprint authentication failed.') //msg --> send to API?
              // error handler with errorcode and localised reason
          } 
        );
      }
      else{
        if(self.state.forceDialog){
          self.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
        }
      }
     
    }

    // window.plugins.touchid.verifyFingerprintWithCustomPasswordFallback(
    //   'Scan your fingerprint please', // this will be shown in the native scanner popup
    //    function(msg) {alert('ok: ' + msg)}, // success handler: fingerprint accepted
    //    function(msg) {alert('not ok: ' + JSON.stringify(msg))} // error handler with errorcode and localised reason
    // );

    // window.plugins.touchid.verifyFingerprintWithCustomPasswordFallbackAndEnterPasswordLabel(
    //   'Scan your fingerprint please', // this will be shown in the native scanner popup
    //   'Enter PIN', // this will become the 'Enter password' button label
    //    function(msg) {alert('ok: ' + msg)}, // success handler: fingerprint accepted
    //    function(msg) {alert('not ok: ' + JSON.stringify(msg))} // error handler with errorcode and localised reason
    // );
  }


  loginUserFromKeychain(){

      var self = this;

      if(window.NativeStorage){
        window.NativeStorage.setItem('medefykeychaincrash', true, ()=>{}, ()=>{});
      }

      window.dasKeychain.getForKey(
        function(passwordValueFromKeychain) {
          //localStorage.setItem('hasLoggedInViaKeychain', object.data.access_token);
          //self.setState({ alertMessage: "PVFK: " + passwordValueFromKeychain, open:true });

          if(passwordValueFromKeychain != "" && passwordValueFromKeychain != null){
            self.props.loginUser(self.state.username, passwordValueFromKeychain);
          }
          else{
            self.setState({ alertMessage: "Unable to authenticate. Please check your username. Logging in with your regular username and password will reset the TouchID.", open: true });
          }
          
        },
        function(err) {
          //alert(err); 
          //console.log('Could not get credentials from keychain.');
          self.setState({ alertMessage: "Please login using your email address and password to enable TouchID", open: true });
        },
        self.state.username,
        'medefyservice'
      );
  }

  authenticate() {
      this.props.loginUser(this.state.username, this.state.password);
  }
  
  usernameChange = (event) => {
      this.setState({ username: event.target.value });
  }

  passwordChange = (event) => {
      this.setState({ password: event.target.value });
  }

  createAccount(){
      //this.props.clearRegState();
      hashHistory.push("/go/newuser");
  }

  forgotLogin = () => {
    this.props.clearRegState();
    hashHistory.push("/go/forgotlogin");
  }

  clearInput(){
    
    if(window.plugins && !this.state.hasBeenTold && this.state.username != "") {
      this.setState({ 
        alertMessage: "If you clear the email field you will be unable to use TouchID authentication. ", 
        open: true, 
        hasBeenTold: true
      });
    }
    else{
      this.setState({username: ""});
      if(window.plugins) {
        this.props.clearToken();
        window.NativeStorage.remove("medefyusername");
      }
    }
  }

  handleClose = () => {
    this.setState({open: false});
  }

  getBoxColor = () => {
    return getMuiTheme(window.muiTheme).palette.alternateTextColor
  }

  render() {

    const actions = [
      <FlatButton
          label="Close"
          primary={true}
          onClick={this.handleClose}
      />
    ];

    const actions2 = [
        <FlatButton
            label="Close"
            primary={true}
            onClick={this.props.hideGlobalMessage}
        />
    ];

    const { isFetching } = this.props

      
    return (
      <div className="bg-unauth" style={{minHeight: 750}}>
          {isFetching && (
              <div className="centered" >
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <CircularProgress color="#fff" /> 
              </div>
          )}

          {!isFetching && (
              <div className="container" >
                <div className="logo" >
                    <div className="logo-login" />
                </div>
                <br />
                <form>
                  <div style={{position: 'relative', display: 'inline-block', width:'100%'}}>
                        {(this.state.allowThumbprint) && (
                          <div onClick={this.clearInput} style={{position: 'absolute', right: -12, top: 4, cursor:'pointer', padding:10, zIndex:99}}>
                          <Clear style={{ color:'#ffffff', width: 20, height: 20, display:'block'}}  />
                          </div>
                         )} 

                        <TextField hintText="Email address" value={this.state.username} onChange={this.usernameChange} inputStyle={{color:"#fff"}} fullWidth={true}  hintStyle={{color:"#fff"}} autoCapitalize="none" type="email" />
                  </div>       
                  <br />
                  <br />

                  <TextField hintText="Password" type="password" value={this.state.password} onChange={this.passwordChange} fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} />
                  <br />
                  {!this.props.isFetching && (
                      <div>
                          {(this.state.allowThumbprint) && (
                            <div style={{textAlign:'center'}}>
                                <p onClick={this.forceDialog} className="white truenoLight" >Sign-In with Touch/Face ID</p>
                            </div>
                          )}
                          <br />
                          <RaisedButton className={'platform-style-button'} label="Log Me In" primary={true} onClick={this.authenticate} fullWidth={true} style={{height:50 }}  labelStyle={{fontSize: '26px', verticalAlign: 'middle'}}  />
                          <br />
                          <br />
                          <FlatButton className={'platform-style-button'} label="Create Account" default={true} fullWidth={true} style={{border: '1px solid #FFF', color:"#fff", height:"50px"}}   labelStyle={{fontSize: '26px'}} onClick={this.createAccount} />
                          <br />
                          <br />
                          <br />
                          <div style={{textAlign: 'center'}} >
                            <FlatButton label="Unable to Login?" default={true} fullWidth={true} style={{ color:"#fff"}} onClick={this.forgotLogin} />
                          </div>
                      </div>
                  )}
                  <Dialog
                        actions={actions}
                        modal={false}
                        open={this.state.open}
                        onRequestClose={this.handleClose} >
                        <p>{this.state.alertMessage }</p>
                    </Dialog>


                    <Dialog
                      title="Message"
                      actions={ actions2 }
                      modal={ false }
                      open={ this.props.openGlobalMessage }
                      >
                      <p>{ this.props.globalMessage }</p>
                  </Dialog>


                  <div className="powered-by-medefy" >
                    <span className="white truenoRegular" >Powered by</span>
                    <img src={`https://${cdnPath}/brands/medefy/medefy-logo-sm.png`} />
                    <br />
                  </div>
                  <div style={{textAlign: '-webkit-center'}} >
                    <span style={{color:'#ffffff', fontSize: 10}}>Build: {buildNumber}</span>
                    {window.COMPANY_ID === 6 && (
                      //code will need changed in the event we have more clients using stepper.
                      <span  style={{color:'#ffffff', fontSize: 10}}><a style={{textDecoration:'none', color:'inherit', fontFamily:'inherit', cursor:'pointer'}} onClick={() => {hashHistory.push('/go/privacy')}}>&nbsp;|&nbsp;Privacy Policy</a></span>
                    )}
                  </div>
                </form>
            </div>
          )}
      </div>
    );
  }

};



const mapDispatchToProps = (dispatch) => {
  return {
    clearRegState: () => {
      dispatch(clearRegState())
    },
    loginUser: (username, password) => {
      dispatch(login(username, password))
    },
    hideGlobalMessage: () => {
        dispatch(hideGlobalMessage());
    },
    clearToken: () => {
        clearToken();
    }
  }
}


function mapStateToProps(state) {
  
  const { isFetching, globalMessage, openGlobalMessage } = state.thisApp.environment;  

  return {
    isFetching, 
    globalMessage, 
    openGlobalMessage
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps)(LoginPage);





// WEBPACK FOOTER //
// ./src/Pages/Login.js